import { useState } from "react";

import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { getDefaultQuantity } from "../../../PriceSelect/getDefaultQuantity";
import { partIsStaggered } from "../../../Tires/Results/Filters/TireSizeFilters/partIsStaggered";

interface QuantityHook {
  (tire?: TirePartItem | null, wheel?: WheelPartItem | null): [
    number,
    (quantity: number) => void
  ];
}

export const useQuantity: QuantityHook = (tire = null, wheel = null) => {
  const wheelQuantity = getDefaultQuantity({
    isStaggered: false,
    orderItem: null,
    part: wheel,
  });

  const isStaggered = partIsStaggered(tire);

  const tireQuantity = getDefaultQuantity({
    isStaggered,
    orderItem: null,
    part: tire,
  });

  const [quantity, setQuantity] = useState(
    Math.min(Number(wheelQuantity), Number(tireQuantity))
  );

  return [quantity, setQuantity];
};
